import { render, staticRenderFns } from "./AddAccreditationItems.vue?vue&type=template&id=7a3a29cf&scoped=true&"
import script from "./AddAccreditationItems.vue?vue&type=script&lang=js&"
export * from "./AddAccreditationItems.vue?vue&type=script&lang=js&"
import style0 from "./AddAccreditationItems.vue?vue&type=style&index=0&id=7a3a29cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3a29cf",
  null
  
)

export default component.exports